import LatinoTemplateDefault from 'src/components/template/la'
import { leagueIds, sportIds } from 'src/constants'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import React from 'react'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/Colombian_PrimeraA_LP_Mobile.jpg"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/Colombian_PrimeraA_LP_Web.jpg"
      title="Watch Liga BetPlay Dimayor without cable"
      subtitle={
        <>
          Get {laChannelCount}+ channels of live TV & sports <br /> in Spanish for only{' '}
          <span className="green-underline">${laDiscountPriceMonthly}</span> your first month
        </>
      }
      networkSet="soccerLatino"
      noteLink="/la/liga-betplay-dimayor-es/"
      sportId={sportIds.Soccer}
      leagueId={leagueIds['Liga BetPlay Dimayor']}
      matchtickerSportId={sportIds.Soccer}
      matchtickerLeagueName="Liga BetPlay Dimayor"
      matchtickerLeagueId={leagueIds['Liga BetPlay Dimayor']}
      additionalFAQs={additionalFAQs}
      laPromoImg="https://assets-imgx.fubo.tv/marketing/lp/images/card/latino/latino-leagues-card.png"
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch Colombian soccer on Fubo?',
    answer:
      'Yes, you can watch Colombian soccer on Fubo, including matches from Liga BetPlay Dimayor (Categoría Primera A). The matches are available on Fubo Latino Network.',
  },
  {
    question: 'How can I find Liga BetPlay Dimayor matches on Fubo?',
    answer:
      'To find Liga BetPlay Dimayor matches on Fubo, simply navigate to the sports section and look for the live events schedule. You can also use the search function to quickly locate specific matches.',
  },
  {
    question:
      'Does Fubo have live coverage of Independiente Santa Fe, Atlético Nacional and other top Liga BetPlay Dimayor teams?',
    answer:
      'Yes, Fubo provides live coverage of the top Categoría Primera A teams including Independiente Santa Fe, Atlético Nacional and others. Tune in to the Fubo Latino Network for real-time action.',
  },
  {
    question: 'Can I watch commentary and analysis for Liga BetPlay Dimayor on Fubo?',
    answer:
      'Absolutely! Fubo features commentary and analysis for Liga BetPlay Dimayor matches, enhancing your viewing experience. Check the schedule for specific shows related to Colombian soccer.',
  },
  {
    question: 'Can I watch Liga BetPlay Dimayor highlights on Fubo?',
    answer:
      'Yes, you can watch highlights of Colombian soccer matches on Fubo. These are typically available shortly after the games conclude, so you can catch up on the action.',
  },
  {
    question: 'What Fubo channel has Liga BetPlay Dimayor?',
    answer:
      'Colombian soccer, including Liga BetPlay Dimayor matches, is available on the Fubo Latino Network and RCN Nuestra Tele Internacional. Make sure to tune in for live games and related programming.',
  },
]
